import React from 'react'
import Form from './Form'
import { formTypeList } from '../../constants/form'

const AddNew = ({ setOpen, itemCategoryId }) => {
    return (
        <Form
            formType={formTypeList.NEW}
            itemCategoryId={itemCategoryId}
            setOpen={setOpen}
        />
    )
}

export default AddNew
